import { Grid, Link, Paper } from "@mui/material";
import { FormattedMessage } from "react-intl";
import { format, parseISO } from "date-fns";
import { Link as RouterLink } from "react-router-dom";

import { humanReadableDateTimeFormat } from "@dzambalaorg/constants";
import type { IOrder } from "@framework/types";
import { List } from "@dzambalaorg/ui-kit";

interface IOrderItemProps {
  order: IOrder;
}
export const OrderItem = (props: IOrderItemProps) => {
  const { order } = props;

  return (
    <Grid size={{ xs: 12 }}>
      <List component={Paper}>
        <List.Item>
          <List.ItemText>
            <FormattedMessage id="pages.orders.date" />
            :&nbsp;
            {format(parseISO(order.createdAt), humanReadableDateTimeFormat)}
          </List.ItemText>
        </List.Item>
        <List.Item>
          <List.ItemText>
            <FormattedMessage id="pages.orders.price" />
            :&nbsp;
            {/* {formatPrice(order.price)} */}
          </List.ItemText>
        </List.Item>
        <List.Item>
          <List.ItemText>
            <FormattedMessage id="pages.orders.status" />
            :&nbsp;
            <FormattedMessage id={`enums.orderStatus.${order.orderStatus}`} />
          </List.ItemText>
        </List.Item>
        <List.Item>
          <List.ItemText>
            <FormattedMessage id="pages.orders.products" />
            :&nbsp;
            <ul>
              {order.orderItems.map(item => (
                <li key={item.id}>
                  <Link component={RouterLink} to={`/ecommerce/products/${item.productItem!.product!.id}`}>
                    {item.productItem!.product!.title}
                  </Link>
                </li>
              ))}
            </ul>
          </List.ItemText>
        </List.Item>
      </List>
    </Grid>
  );
};
